import {GuidService} from '../services/guid.service';
export class CmdBaseModel {

    id?: string;
    constructor(id?:string){
        this.id = id;
    }
}